export const WAGES_TABLE_COLUMNS = [
  { accessorKey: "$", header: "ردیف" },
  { accessorKey: "date", header: "تاریخ" },
  // { accessorKey: "terminalId", header: "شناسه ترمینال" },
  {
    accessorKey: "settlementAmount",
    header: "مبلغ واریزی تسویه حساب (ریال) ",
    size: 300,
  },
  { accessorKey: "wage", header: "کارمزد تسویه (ریال)" },
  { accessorKey: "acceptorCode", header: "کد پذیرندگی" },
  // { accessorKey: "trackingNumber", header: "کد رهگیری" },
  // { accessorKey: "transactionId", header: "شناسه تراکنش" },
  // { accessorKey: "referenceNumber", header: "کد مرجع" },
  { accessorKey: "isProcess", header: "وضعیت تسویه تراکنش", size: 250 },
];
